import { useAxios } from "@/config";
import {
  Data8AddressRetrieveResponse,
  Data8AddressSearchOption,
  Data8AddressSearchResponse,
  Data8Provider,
  ProviderType,
} from "@/types";
import { data8ResultToLocation } from "@/util/locationFactory";
import { defineStore } from "pinia";
import { useLocation } from "./location";
import { useOrgSettings } from "./orgSettings";

interface Data8State {
  configuration: any;
  options: Data8AddressSearchOption[];
  sessionId: string | undefined;
}
export const useData8 = defineStore("data8", {
  state: (): Data8State => ({
    configuration: {},
    options: [],
    sessionId: undefined,
  }),
  getters: {
    providerSettings(): Data8Provider | undefined {
      return useOrgSettings().addressSettings?.providers.find(
        (x) => x.providerType === ProviderType.Data8
      ) as Data8Provider | undefined;
    },
  },
  actions: {
    async loadOptions(keyword: string | undefined): Promise<void> {
      if (!keyword || !this.providerSettings) {
        this.options = [];
        return;
      }

      const { country, api, licenceKey } = this.providerSettings;
      const url = `${api.base}${api.autocomplete}?key=${licenceKey}`;
      const result = await useAxios().$http.post<Data8AddressSearchResponse>(
        url,
        {
          country: country,
          search: keyword,
          telephoneNumber: "",
          session: this.sessionId,
          options: {
            PreferredLanguage: "en",
            IncludeNYB: false,
            IncludeMR: false,
            ApplicationName: api.applicationName,
          },
        }
      );

      this.sessionId = result.data.SessionID;
      this.options = result.data.Results;
    },

    async selectAddress(
      selectedAddress: Data8AddressSearchOption | undefined
    ): Promise<void> {
      if (!selectedAddress || !this.providerSettings) {
        this.options = [];
        return;
      }

      const { country, api, licenceKey } = this.providerSettings;
      const url = `${api.base}${api.findAddress}?key=${licenceKey}`;
      const result = await useAxios().$http.post<Data8AddressRetrieveResponse>(
        url,
        {
          country: country,
          id: selectedAddress.value,
          options: {
            IncludeLocation: true,
            IncludeUPRN: true,
          },
        }
      );

      const location = data8ResultToLocation(result.data);
      useLocation().updateLocation(location);
    },
  },
});
